import React, { PropTypes } from 'react';
import { FlatButton } from 'material-ui';
import StepperActions from '../stepper-actions';
import RateSetInfoTemplate from '../rate-forms/rate-set-info-template.jsx';

const RateSetInfo = props => {
  const {
    updateFieldValue,
    updateDaysOfWeek,
    goToNextStep,
    cancelFunc,
    cancelText,
    componentIndex,
    productType,
    productName,
    usedRateSetNamesAndCodes,
    getOverlappingDaysError,
    ...fieldValues,
  } = props;
  const rateSetNameAndCodeError = (() => {
    if (usedRateSetNamesAndCodes && usedRateSetNamesAndCodes.some(nameAndCode => {
        if (nameAndCode.rateSetName === fieldValues.rateSetName) {
          if (!nameAndCode.rateSetCode && !fieldValues.rateSetCode) return true;
          return nameAndCode.rateSetCode === fieldValues.rateSetCode;
        }
      })) {
      return `You have already entered a ${fieldValues.rateSetName} rate set using ${fieldValues.rateSetCode ? `the ${fieldValues.rateSetCode}` : ' an empty'} rate set code for this season. Please enter a new rate set name or rate set code so your agents know which rate is applicable.`;
    }
  })();
  const overlappingDaysError = getOverlappingDaysError ? getOverlappingDaysError(fieldValues) : '';
  const shouldDisableContinue = Boolean(!fieldValues.rateSetName || !(fieldValues.daysOfWeek && fieldValues.daysOfWeek.length) || rateSetNameAndCodeError || overlappingDaysError);
  return (
    <div style={{ padding: '24px' }}>
      <RateSetInfoTemplate
        {...fieldValues}
        overlappingDaysError={overlappingDaysError}
        rateSetNameAndCodeError={rateSetNameAndCodeError}
        productName={productName}
        productType={productType}
        updateFieldValue={(fieldName, value) => updateFieldValue({ fieldName, value })}
        updateDaysOfWeek={(checked, day, dayIndexInReducer) => updateDaysOfWeek({ checked, day, dayIndexInReducer })}
      />
      <br />
      <br />

      <StepperActions
        rightButtons={
        <div>
          <FlatButton
            label={cancelText}
            labelStyle={{ fontWeight: '600', marginRight: '15px' }}
            primary
            onTouchTap={cancelFunc}
          />
          <FlatButton
            label={'Continue'}
            labelStyle={{ fontWeight: '600' }}
            disabled={shouldDisableContinue}
            onTouchTap={() => {
             goToNextStep(componentIndex);
            }}
            secondary
          />
        </div>
        }
      />
    </div>
  );
};

RateSetInfo.propTypes = {
  updateFieldValue: PropTypes.func,
  updateDaysOfWeek: PropTypes.func,
  goToNextStep: PropTypes.func,
  cancelFunc: PropTypes.func,
  cancelText: PropTypes.string,
  componentIndex: PropTypes.number,
  fieldValues: PropTypes.object,
};

export default RateSetInfo;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/add-rates-wizard/1-rate-set-info.jsx